<main style="padding: 5%;">
    <h2 style="text-align: center;margin-bottom: 1vh;">Участники задачи</h2>
    <ng-container *ngIf="taskData.roles && showRoles">
        <ng-container
                *ngTemplateOutlet="users; context: {data: {name: 'TASKS.DETAIL.TEXT.RESPONSIBLE' | translate, role: 'responsible', users: taskData.roles.responsible}}">
        </ng-container>
        <ng-container
                *ngTemplateOutlet="users; context: {data: {name: 'TASKS.DETAIL.TEXT.EXECUTORS' | translate, role: 'executor', users: taskData.roles.executor}}">
        </ng-container>
        <ng-container
                *ngTemplateOutlet="users; context: {data: {name: 'TASKS.DETAIL.TEXT.OBSERVERS' | translate, role: 'observer', users: taskData.roles.observer}}">
        </ng-container>
        <ng-container
                *ngTemplateOutlet="users; context: {data: {name: 'TASKS.DETAIL.TEXT.CONTRACT_OBSERVERS' | translate, role: 'observer_contract', users: taskData.roles.observer_contract}}">
        </ng-container>
    </ng-container>
    <ng-template #users let-data="data">
        <ng-container *ngIf="data && data['users'].length">
            <h3> {{ data.name }}: </h3>
            <ul class="task__users__list">
                <ng-container *ngFor="let user of data['users']; let i = index">
                    <li [attr.data-content]="data.name"
                        [attr.data-index]="i">
					<span (click)="profile(user['guid'])"
                          class="user_profile"
                          data-action="openProfile">
						<img *ngIf="is_project_admin"
                             alt="#"
                             ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}"
                             src="../../../../assets/images/admin.svg">
                        {{ helpersService.shortFullName(user, false) }}
					</span>
                    </li>
                </ng-container>
            </ul>
        </ng-container>
    </ng-template>
</main>
